import Ajax from '@/lib/ajax'

export default {
  /**
   * 获取商品评论列表
   */
  getList(pageSize: number, currentPage: number, keyWord?: string, IncludeBadReview?: boolean) {
    let params = {
      keyWord,
      IncludeBadReview,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    }
    console.log(params)
    return Ajax.get('/api/productManagement/productreview', {
      params: params
    })
  },

  /**
   * 批量更新评论展示状态
   */
  updatePublished(ids: string[], published: boolean) {
    return Ajax.put(`/api/productManagement/productreview/published`, {
      ids,
      published
    })
  },

  /**
   * 批量删除商品评论
   * @param ids 
   */
  deleteProductreview(ids: string[]) {
    return Ajax.delete(`/api/productManagement/productreview`, {
      params: {
        ids
      }
    })
  },

  /**
   * 获取商品评价信息
   */
  getProductreviewInfo(id: string) {
    return Ajax.get(`/api/productManagement/productreview/${id}`)
  },

  /**
   * 管理员回复商品评论
   */
  replyFn(id: string, content: string) {
    return Ajax.put(`/api/productManagement/productreview/reply/${id}`, {
      content
    })
  }
}
